const normalizedUID = uid => typeof uid === 'string' && uid.length > 0 ? uid : null

/**
 * Monotonic epoch attached to WebView -> native identity messages.
 * Async token work captures a snapshot before it starts; a later auth change
 * makes that work stale without ever putting a credential in the epoch itself.
 */
export class NativeAuthGeneration {
  generation = 0
  uid = undefined

  transitionToUID = uid => {
    const nextUID = normalizedUID(uid)
    if (this.uid === undefined || this.uid !== nextUID) {
      this.generation += 1
      this.uid = nextUID
    }
    return this.snapshot()
  }

  beginSignOut = () => {
    this.generation += 1
    this.uid = null
    return this.snapshot()
  }

  snapshot = () => ({
    authGeneration: this.generation,
    authUID: this.uid === undefined ? null : this.uid
  })

  isCurrent = (snapshot, currentUID) => Boolean(
    snapshot &&
    snapshot.authGeneration === this.generation &&
    snapshot.authUID === normalizedUID(currentUID)
  )
}
